import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import background from '../images/footerbg.png'
import Logo from '../images/logo.png'
import ImgFooter from '../images/OBC.png'

import {
  FaLocationDot,
  FaEnvelope,
  FaPhone,
  FaFacebook,
  FaLinkedin,
  FaXTwitter,
  FaInstagram,
} from 'react-icons/fa6'

gsap.registerPlugin(ScrollTrigger)

function Footer() {
  const footerRef = useRef(null)
  const columnsRef = useRef(null)
  const bottomRef = useRef(null)
  const illustrationRef = useRef(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: footerRef.current,
          start: 'top 82%',
          once: true,
        },
        defaults: { ease: 'power3.out' },
      })

      tl.from(columnsRef.current.children, {
        opacity: 0,
        y: 24,
        duration: 0.6,
        stagger: 0.08,
      })
        .from(
          bottomRef.current.children,
          {
            opacity: 0,
            y: 18,
            duration: 0.45,
            stagger: 0.08,
          },
          '-=0.2'
        )
        .from(
          illustrationRef.current,
          {
            opacity: 0,
            y: 24,
            scale: 0.97,
            duration: 0.7,
          },
          '-=0.35'
        )
    }, footerRef)

    return () => ctx.revert()
  }, [])

  return (
    <footer
      className="footer"
      style={{ backgroundImage: `url(${background})` }}
      ref={footerRef}
    >
      <div className="footer-container" ref={columnsRef}>
        <div className="footer-about">
          <img src={Logo} alt="OBC Logo" className="footer-logo" />

          <p>
            OBC Cards & Collectibles isn&apos;t your typical marketplace. This is a
            high-voltage trading arena where every card drop feels like a casino
            hand, every auction feels like overtime in a championship game, and
            every win hits like a buzzer-beater. Built for collectors who crave
            adrenaline, precision, and control - whether you&apos;re here to bid, buy,
            or build your legacy collection.
          </p>
        </div>

        <div className="footer-links">
          <h3>Main Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/live-auctions">Live Auctions</a></li>
            <li><a href="/shop">Buy Now Shop</a></li>
            <li><a href="/vault">The Vault</a></li>
            <li><a href="/weekly-bundle">Weekly Bundle</a></li>
            <li><a href="/consign-with-us">Consign With Us</a></li>
            <li><a href="/about">About</a></li>
          </ul>
        </div>

        <div className="footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/terms-and-conditions">Terms & Conditions</a></li>
            <li><a href="/return-refund-policy">Return & Refund Policy</a></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="/drops-schedule">Drops & Schedule</a></li>
            <li><a href="/support">Support</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-contact">
          <h3>Reach Us Out</h3>

          <div className="contact-item">
            <FaLocationDot />
            <span>204 N Main Street pmb 42 Watford City ND 58854</span>
          </div>

          <div className="contact-item">
            <FaEnvelope />
            <a href="mailto:cvinderise@yahoo.com">cvinderise@yahoo.com</a>
          </div>

          <div className="contact-item">
            <FaPhone />
            <a href="tel:6058655068">605-865-5068</a>
          </div>

          <div className="footer-socials">
            <button type="button" aria-label="Facebook"><FaFacebook /></button>
            <button type="button" aria-label="LinkedIn"><FaLinkedin /></button>
            <button type="button" aria-label="X"><FaXTwitter /></button>
            <button type="button" aria-label="Instagram"><FaInstagram /></button>
          </div>
        </div>
      </div>

      <div className="footer-bottom" ref={bottomRef}>
        <p>Copyright 2026 | OBC Cards & Collectibles | All Rights Reserved</p>
        <p>
          Powered By <a href="https://designversestudios.com/">Design Verse Studios</a>
        </p>
      </div>

      <div className="footer-illustration" aria-hidden="true" ref={illustrationRef}>
        <img
          src={ImgFooter}
          alt=""
          className="footer-illustration__img"
        />
      </div>
    </footer>
  )
}

export default Footer
